import customHeaders, { getSpace } from '../../common/headers';
import { TabsGreyBtn } from '../../components/TabsGreyBtn/TabsGreyBtn';
import { ModalCreateGroup } from '../../components/Modal/ModalCreateGroup/ModalCreateGroup';
import { useEffect, useState } from 'react';
import { ButtonBasic, SceletonListPreview, ButtonClose } from "@lk-gtcom/ecomlab-components";
import { ChatPreview } from './ChatPreview/ChatPreview';
import { AuthorAvatar } from '../ArticleComponents/AuthorAvatar/AuthorAvatar';
import useGeneralStore from '../../store/general';
import { ChatComment } from '../ComponentsCommonTasksLogic/ChatTask/ChatComment';
import "./ChatMessagePage.scss"
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { useShallow } from 'zustand/react/shallow';


const ChatMessagePage = ({ isModal, setIsModalChat }) => {
    const selectedSpace = useGeneralStore(state => state.selectedSpace)
    const headers = { ...customHeaders, ...getSpace(selectedSpace) }
    const client_id = localStorage.getItem('client_id');
    const navigate = useNavigate();
    const path = useParams();
    const {
        chatListNotification,
        setChatListNotification,
        userStatus,
        unreadCountPersonal,
        unreadCountGroup
    } = useGeneralStore(
        useShallow((state) => ({
            userStatus: state.userStatus,
            chatListNotification: state.chatListNotification,
            setChatListNotification: state.setChatListNotification,
            unreadCountPersonal: state.unreadCountPersonal,
            unreadCountGroup: state.unreadCountGroup,
        }))
    );

    const btns = [
        {
            label: 'Чаты',
            count: unreadCountPersonal,
            value: 'Все'
        },
        {
            label: 'Группы',
            count: unreadCountGroup,
            value: 'Группы'
        }
    ]

    const [isEditGroup, setIsEditGroup] = useState(false)
    const [isModalCreateGroup, setIsModalCreateGroup] = useState(false)
    const [chatList, setChatList] = useState([])
    const [usersList, setUsersList] = useState([])
    const [status, setStatus] = useState(btns?.[0]?.value)
    const [currentProject, setCurrentProject] = useState(-1)
    const [currentMessage, setCurrentMessage] = useState({})
    const [isCreateChat, setIsCreateChat] = useState(false)
    const [isLoadingPreview, setIsLoadingPreview] = useState(false)

    const [isWidget, setIsWidget] = useState(false)
    const [isMinWidget, setIsMinWidget] = useState(false)

    // Получить список юзеров в спейсе
    const fetchGetUsers = (id) => {
        let url = `https://apps1.ecomru.ru:4444/space/users`

        fetch(url, { method: 'GET', headers })
            .then(res => {
                if (res.ok) {
                    return res.json()
                } else {
                    throw new Error('bad resp')
                }
            })
            .then(json => {
                setUsersList(json)
            })
            .catch(err => console.error(err))
    }

    // Создать чат
    const createChat = (id) => {
        let url = `https://apps1.ecomru.ru:4444/space/chats`

        const body = JSON.stringify({
            client_id: id
        })

        fetch(url, { body, method: 'POST', headers })
            .then(res => {
                if (res.ok) {
                    return res.json()
                } else {
                    throw new Error('bad resp')
                }
            })
            .then(json => {
                if (isCreateChat) {
                    fetchChatList(currentProject?.project_id)
                } else {
                    fetchGroup(currentProject?.project_id)
                }
            })
            .catch(err => console.error(err))
    }

    // Создать групповой чат групп
    const createGroup = (ids, group_name) => {
        setIsModalCreateGroup(false)
        let url = `https://apps1.ecomru.ru:4444/space/group`

        const body = JSON.stringify({
            client_ids: ids,
            group_name
        })

        fetch(url, { method: 'POST', body, headers })
            .then(res => {
                if (res.ok) {
                    return res.json()
                } else {
                    throw new Error('bad resp')
                }
            })
            .then(json => {
                if (isCreateChat) {
                    fetchChatList(currentProject?.project_id)
                } else {
                    fetchGroup(currentProject?.project_id)
                }
            })
            .catch(err => console.error(err))
    }

    // Получить чаты
    const fetchChatList = (abortController = new AbortController()) => {
        setIsLoadingPreview(true)
        let url = `https://apps1.ecomru.ru:4444/space/chats`

        fetch(url, { method: 'GET', headers, signal: abortController.signal })
            .then(res => {
                if (res.ok) {
                    return res.json()
                } else {
                    throw new Error('bad resp')
                }
            })
            .then(json => {
                setChatList(json)
            })
            .catch(err => console.error(err))
            .finally(() => {
                setIsLoadingPreview(false)
                if (abortController.signal.aborted) {
                    return;
                }
            })

        // setChatList(json.map(el => ({ ...el, name: el?.chat_name?.name })))

    }

    // Получить группы
    const fetchGroup = (abortController = new AbortController()) => {
        setIsLoadingPreview(true)
        let url = `https://apps1.ecomru.ru:4444/space/group`

        fetch(url, { method: 'GET', headers, signal: abortController.signal })
            .then(res => {
                if (res.ok) {
                    return res.json()
                } else {
                    throw new Error('bad resp')
                }
            })
            .then(json => {
                setChatList(json)
            })
            .catch(err => console.error(err))
            .finally(() => {
                setIsLoadingPreview(false)
                if (abortController.signal.aborted) {
                    return;
                }
            })
    }

    // Выйти из чата
    const fetchDeleteChat = (chat_id) => {
        // setIsLoadingPreview(true)

        let url = `https://apps1.ecomru.ru:4444/space/chats/${chat_id}/leave`

        fetch(url, { method: 'DELETE', headers })
            .then(res => {
                if (res.ok) {
                    return res.json()
                } else {
                    throw new Error('bad resp')
                }
            })
            .then(json => {
                setTimeout(() => fetchChatList(), 1000)
                setCurrentMessage(null)
            })
            .catch(err => console.error(err))
            .finally(() => setIsLoadingPreview(false))
    }

    // Выйти из группы
    const fetchDeleteGroup = (chat_id) => {
        // setIsLoadingPreview(true)
        let url = `https://apps1.ecomru.ru:4444/space/group/${chat_id}/leave`

        fetch(url, { method: 'DELETE', headers })
            .then(res => {
                if (res.ok) {
                    return res.json()
                } else {
                    throw new Error('bad resp')
                }
            })
            .then(json => {
                setTimeout(() => fetchGroup(), 1000)
                setCurrentMessage(null)
            })
            .catch(err => console.error(err))
            .finally(() => setIsLoadingPreview(false))
    }

    //Изменение названия группы
    const editGroup = (chat_id, group_name) => {
        setIsModalCreateGroup(false)
        let url = `https://apps1.ecomru.ru:4444/space/group/${chat_id}/update/change-group-name`

        const body = JSON.stringify({
            group_name: group_name
        })

        fetch(url, { method: 'PATCH', body, headers })
            .then(res => {
                if (res.ok) {
                    return res.json()
                } else {
                    throw new Error('bad resp')
                }
            })
            .then(json => {
                fetchGroup(currentProject?.project_id)
            })
            .catch(err => console.error(err))
    }

    // Добавить участника 
    const fetchAddUsers = (chat_id, client_ids) => {
        let url = `https://apps1.ecomru.ru:4444/space/group/${chat_id}/update/add-interlocutors`

        const body = JSON.stringify({
            client_ids: [client_ids]
        })

        fetch(url, { method: 'PATCH', body, headers })
            .then(res => {
                if (res.ok) {
                    return res.json()
                } else {
                    throw new Error('bad resp')
                }
            })
            .then(json => {
                fetchGroup(currentProject?.project_id)
            })
            .catch(err => console.error(err))
    }

    // Удалить участника 
    const fetchDeleteUsers = (chat_id, client_ids) => {
        let url = `https://apps1.ecomru.ru:4444/space/group/${chat_id}/update/delete-user`

        const body = JSON.stringify({
            client_ids: [client_ids]
        })

        fetch(url, { method: 'DELETE', body, headers })
            .then(res => {
                if (res.ok) {
                    return res.json()
                } else {
                    throw new Error('bad resp')
                }
            })
            .then(json => {
                fetchGroup(currentProject?.project_id)
            })
            .catch(err => console.error(err))
    }

    useEffect(() => {
        const abortController = new AbortController();
        if (status === btns?.[0]?.value) {
            fetchChatList(abortController)
        }
        if (status === btns?.[1]?.value) {
            fetchGroup(abortController)
        }
        return () => abortController.abort();
    }, [status])

    useEffect(() => {
        fetchGetUsers()
    }, []);

    const returnChat = () => {
        return <ChatComment
            chatId={currentMessage?.chat?.chat_id}
            authorId={client_id}
        />
    }

    const renderHeader = () => {
        return <>
            <div className='chat_message_page__avatar-box'>
                {currentMessage?.members?.map(({ name, login, color, id }) =>
                    <AuthorAvatar
                        size='s'
                        show_name={status == 'Все'}
                        group={status !== 'Все'}
                        key={name + login}
                        author={[name, color]}
                        color={color}
                        showTooltip
                        isStatus={true}
                        status={userStatus.includes(id)}
                    />


                )}
            </div>

            <TitlePage
                medium
                title={currentMessage?.name ? currentMessage?.name : currentMessage?.chat_name?.name}
            />
        </>
    }

    return (
        <>
            {isModalCreateGroup && <ModalCreateGroup
                status={status}
                setIsModal={(e) => setIsModalCreateGroup(e)}
                isEdit={isEditGroup}
                setIsEdit={(e) => setIsEditGroup(e)}
                createGroup={createGroup}
                createChat={createChat}
                type={isCreateChat}
                usersList={usersList}
                currentMessage={currentMessage}
                editGroup={editGroup}
                fetchAddUsers={fetchAddUsers}
                fetchDeleteUsers={fetchDeleteUsers}
                fetchUsers={fetchGetUsers}
            />}

            {isWidget
                ?
                <div className={!isMinWidget ? 'chat_message_page__widget' : 'chat_message_page__widget_min'}>
                    <header
                        onClick={(e) => {
                            if (isMinWidget) {
                                setIsMinWidget(false)
                            }
                        }}
                        className={!isMinWidget ? 'chat_message_page__widget-header' : 'chat_message_page__widget-header_min'}
                    >
                        {renderHeader()}

                        <div className='chat_message_page__widget-close'>
                            {!isMinWidget && <>
                                <ButtonClose
                                    s
                                    minimize
                                    onClick={(e) => setIsMinWidget(true)}
                                />
                                <ButtonClose
                                    s
                                    maximize
                                    onClick={(e) => setIsWidget(false)}
                                />
                            </>}

                            <ButtonClose
                                s
                                onClick={(e) => setIsModalChat(false)}
                            />
                        </div>
                    </header>
                    {<div className={!isMinWidget ? 'chat_message_page__widget-content' : 'chat_message_page__widget-content_hide'}>
                        {returnChat()}
                    </div>}
                </div>
                :
                <div className={isModal ? 'blackout' : ''}>
                    <div className='chat_message_page' onClick={e => e.stopPropagation()}>
                        <div className='chat_message_page__side-panel'>
                            <header className='chat_message_page__header'>
                                <div className='chat_message_page__btn-panel'>
                                    <TabsGreyBtn
                                        btns={btns}
                                        currentBtn={status}
                                        setCurrentBtn={(e) => {
                                            setChatList([])
                                            setCurrentMessage({})
                                            setStatus(e)
                                        }}
                                        checkValue={true}
                                    />

                                    {status != 'Все' && <ButtonBasic
                                        green
                                        size='32px'
                                        width='auto'
                                        text='+ Новая группа'
                                        onClick={(e) => {
                                            setIsModalCreateGroup(true)
                                            setIsCreateChat(false)
                                        }}
                                    />}

                                    {status == 'Все' && <ButtonBasic
                                        green
                                        size='32px'
                                        width='auto'
                                        text='+ Новый чат'
                                        onClick={e => {
                                            setIsModalCreateGroup(true)
                                            setIsCreateChat(true)
                                        }}
                                    />}
                                </div>

                            </header>

                            <div className='chat_message_page__list-message'
                                style={{ overflow: isLoadingPreview ? 'hidden' : '' }}>
                                {
                                    isLoadingPreview ?
                                        <SceletonListPreview
                                        />
                                        :
                                        (chatList?.length > 0 ? chatList?.map((props) => {

                                            if (status == 'Все') {
                                                return <ChatPreview
                                                    userStatus={userStatus}
                                                    type={'chat'}
                                                    {...props}
                                                    currentMessage={currentMessage}
                                                    setCurrentMessage={(e) => {
                                                        setCurrentMessage(e)
                                                    }}
                                                    deleteFunc={fetchDeleteChat}
                                                    chatListNotification={chatListNotification}
                                                />
                                            }
                                            else {
                                                return <ChatPreview
                                                    userStatus={userStatus}
                                                    {...props}
                                                    setIsEditGroup={(e) => setIsEditGroup(e)}
                                                    setIsModalCreateGroup={(e) => setIsModalCreateGroup(e)}
                                                    currentMessage={currentMessage}
                                                    setCurrentMessage={(e) => {
                                                        setCurrentMessage(e)
                                                    }}
                                                    deleteFunc={fetchDeleteGroup}
                                                    chatListNotification={chatListNotification}
                                                />
                                            }
                                        })
                                            :
                                            <div
                                                className='text_grey'
                                                style={{
                                                    margin: '0 auto',
                                                    height: '100%',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    fontSize: 14
                                                }}
                                            >
                                                Нет доступных чатов
                                            </div>
                                        )
                                }
                            </div>
                        </div>

                        <div className='chat_message_page__message-comtent'>
                            <header className='chat_message_page__header-message'>
                                {renderHeader()}

                                {isModal &&
                                    <div className='chat_message_page__header-btns'>
                                        {currentMessage?.chat?.chat_id
                                            &&
                                            <ButtonClose
                                                m
                                                minimize
                                                onClick={(e) => setIsWidget(true)}
                                            />}

                                        <ButtonClose
                                            m
                                            maximize
                                            onClick={(e) => {
                                                setIsModalChat(false)
                                                navigate('/chat')
                                            }}
                                        />

                                        <ButtonClose
                                            onClick={(e) => setIsModalChat(false)}
                                        />
                                    </div>}
                            </header>

                            <div className='chat_message_page__content-chat'>
                                {currentMessage?.chat?.chat_id
                                    ?
                                    returnChat()
                                    :
                                    <div
                                        className='text_grey'
                                        style={{
                                            width: '100%',
                                            margin: '0 auto',
                                            height: '100%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: 14
                                        }}
                                    >
                                        Выберите чат
                                    </div>
                                }
                            </div>
                        </div>
                    </div >
                </div>
            }
        </>
    )
}

export { ChatMessagePage }